export { default } from './HeroImages';
